import { createRoute, lazyFn } from '@tanstack/react-router';
import { z } from 'zod/v4-mini';

import { RootRoute } from '$/routes/RootRoute';

export const InspirationEditorRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/inspirations/$id',
  validateSearch: (search) =>
    z
      .object({
        harmonyId: z.optional(z.string()),
        materialId: z.optional(z.string()),
        applyTo: z.optional(z.literal('main-wall')),
      })
      .parse(search),
  loader: lazyFn(() => import('./InspirationEditorRoute.lazyFn'), 'loader'),
  onLeave: lazyFn(() => import('./InspirationProjectRoute.lazyFn'), 'onLeave'),
  staleTime: 0,
  preload: false,
}).lazy(() =>
  import('./InspirationEditorRoute.lazy').then(
    (d) => d.LazyInspirationEditorRoute,
  ),
);
